import {formatISO} from '@shared/helpers/date'

import {getSettlementDetail} from '@web/actions/saleSettlement'
import {getInitialState} from '@web/slices/transactionHistory/slice'
import makeSlice from '@web/slices/transactionHistory/sliceMaker'

import {getSettleObjectName} from '../../constants'

const transactionHistorySlice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(getSettlementDetail.pending, () => {
                return getInitialState()
            })
            .addCase(getSettlementDetail.fulfilled, (state, {payload}) => {
                const {settleByCases} = payload

                if (settleByCases) {
                    state.priceItems = settleByCases.map(
                        ({settleObjectNo, settleObjectType, settleYmd, settleAmount, productName}) => {
                            return {
                                id: settleObjectNo,
                                name: productName || getSettleObjectName(settleObjectType),
                                date: formatISO(settleYmd, {inputFormat: 'yyyyMMdd'}) ?? '',
                                amount: settleAmount,
                            }
                        },
                    )
                }
            })
    },
})

export default transactionHistorySlice.reducer
